import "./style.scss";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Html from "./Html";
import environment from "../../../environment";
import { useEffect, useState } from "react";
import { sidebar_base } from "../../../actions/sidebar";
const Sidebar = ({ isOpen }) => {
  const user = useSelector((state) => state.user);
  const logedInUser = JSON.parse(sessionStorage.getItem('logedInUser') || JSON.stringify(user))
  const dispatch = useDispatch();
  const history = useNavigate();
  const [SidebarLoad, setSidebarLoad] = useState(false);
  const sidebarCollapseData = useSelector((state) => state.sidebar);
  const [CollapsedState, setCollapsedState] = useState(
    sidebarCollapseData?.value
  );
  const [expandAll, setExpandAll] = useState(false);

  useEffect(() => {
    // setSidebarLoad(true)
    setCollapsedState(sidebarCollapseData?.value);
  }, [sidebarCollapseData?.value]);
   const menus = {
    omni: ["omni-channels","/omni-channel-setting/integration","chatbot","voice-ai","/omni-channel-setting/widget"],
  };
 
  const ListItemLink = ({ to, type = "link", disabled = false, ...rest }) => {
    let url = location.href;
    const host = location.host;
    url = url?.split(host)[1];
    return (
      <>
        {type == "link" ? (
          <li className={`nav-item ${url.includes(to) ? "active" : ""}`}>
            <Link
              to={to}
              {...rest}
              className={`nav-link hoverclass ${disabled ? "disabled" : ""}`}
              disabled={disabled}
            />
          </li>
        ) : (
          <li
            className={`nav-item main ${url.includes(to) ? "active" : ""}`}
            {...rest}
          ></li>
        )}
      </>
    );
  };
 

  const tabclass = (tab) => {
    let url = location.href;
    let value = false;
    menus[tab].map((itm) => {
      if (
        (url.includes(itm) && CollapsedState) ||
        sidebarCollapseData?.allState
      )
        value = true;
    });
    // alert(CollapsedState)

    return value;
  };
  const urlAllow = (url) => {
    let permissions =
      logedInUser?.permissions ||
      user?.permissions ||
      (logedInUser?.subRole?.permissions && logedInUser?.subRole?.permissions[0]) ||
      (user?.subRole?.permissions && user?.subRole?.permissions[0]);

    // If no restricted permissions exist, root Super Admin has unrestricted access
    if (!permissions) return true;

    let arr = url?.split(",") || [];
    let value = false;
    arr.forEach((itm) => {
      const trimmed = itm.trim();
      const normalized = trimmed.toLowerCase().replace(/-/g, "_");

      if (permissions[normalized] && typeof permissions[normalized] === "object") {
        if (permissions[normalized].view) value = true;
      } else if (permissions[trimmed] && typeof permissions[trimmed] === "object") {
        if (permissions[trimmed].view) value = true;
      } else if (permissions[trimmed] || permissions[normalized]) {
        value = true;
      }
    });

    if (user?.subRole?.id || user?.subRole?._id || user?.permissions || logedInUser?.permissions) {
      return value;
    } else {
      return true;
    }
  };

  const route = (p) => {
    history(p);
  };

  return (
    <>
      <Html
        route={route}
        CollapsedState={CollapsedState}
        setCollapsedState={setCollapsedState}
        tabclass={tabclass}
        ListItemLink={ListItemLink}
        urlAllow={urlAllow}
        isOpen={isOpen}
        SidebarLoad={SidebarLoad}
        setSidebarLoad={setSidebarLoad}
        expandAll={expandAll}
        setExpandAll={setExpandAll}
      />
    </>
  );
};

export default Sidebar;
